











































import { defineComponent, ref, computed, onMounted, onUpdated } from '@vue/composition-api';
import Videos from '@/data/Videos';
import VideoPreview from '@/components/VideoPreview.vue';
import SharedState from '@/data/SharedState';

export default defineComponent({
  name: 'RelatedVideos',
  components: {
    VideoPreview    
  },
  props: {
    relatedVideos: {
      type: Videos,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 0
    },
    loadError: {
      type: Boolean,
      default: false
    },
    loadedOnce: {
      type: Boolean,
      default: true
    }
  },
  emits: {
    'video-selected': (/*videoId: string*/) => true
  },
  setup(props, context) {
    
    const hasScrollbar = ref(false);
    const ulElem = ref<HTMLUListElement|null>(null);
   
    const videos = computed(() => {
      return props.relatedVideos.videos.slice();
    });
    const heightC = computed(() => {
      return props.height !== 0 
        ? props.height + 'px'
        : 'auto';
    });
    const hasVideos = computed(() => {
      return props.relatedVideos.videos.length > 0;
    });
    const videoCount = computed(() => {
      return props.relatedVideos.videos.length;
    });
    const title = computed(() => {
      if(props.loadError) {
        return SharedState.getText(context, 'corptube.similar.load.error');
      }

      return hasVideos.value
        ? SharedState.getText(context, 'corptube.similar.videos')
        : SharedState.getText(context, 'corptube.similar.none.found');
    });
    const loadingText = computed(() => {
      return SharedState.getText(context, 'corptube.videocount.loading');
    });


    const hasScrollbarFn = (): boolean => {
      if(!ulElem.value) return false;
      const grandParent = ulElem.value?.parentElement?.parentElement;
      if(!grandParent) return false;
      return ulElem.value.clientHeight > grandParent.clientHeight;
    };

    const updateScrollbarDisplay = () => {
      const result = hasScrollbarFn();
      if(result != hasScrollbar.value) {
        hasScrollbar.value = result;
      }
    };

    onUpdated(() => {
      setTimeout(() => {
        updateScrollbarDisplay();
      }, 100);
    });

    onMounted(() => {
      updateScrollbarDisplay();
    });

    return  {
      videos,
      heightC,
      title,
      hasScrollbar,
      ulElem,
      hasVideos,
      videoCount,
      loadingText
    };
  }
});
